var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8958 37.4138C12.4768 39.4496 3.51229 43.6066 8.97227 48.8084C11.6394 51.3493 14.6099 53.1666 18.3446 53.1666H39.6553C43.39 53.1666 46.3606 51.3493 49.0277 48.8084C54.4876 43.6066 45.5232 39.4496 42.1041 37.4138C34.0866 32.6397 23.9134 32.6397 15.8958 37.4138Z",
    stroke: "black",
    strokeWidth: 3.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.875 15.7084C39.875 21.7145 35.0061 26.5834 29 26.5834C22.9939 26.5834 18.125 21.7145 18.125 15.7084C18.125 9.70228 22.9939 4.83337 29 4.83337C35.0061 4.83337 39.875 9.70228 39.875 15.7084Z",
    stroke: "black",
    strokeWidth: 3.625
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.832b37f948d7f6ae4fd8e78549f795f8.svg";
export { ForwardRef as ReactComponent };